import React from 'react';
import { Button } from '../shared/Button';
import { ArrowRightIcon, CalendarIcon } from 'lucide-react';
export const CTASection = () => {
  return <section className="w-full bg-gradient-to-br from-[#231232] via-[#1a0d24] to-[#231232] py-20 sm:py-28 border-t border-b border-[#6805DA]/20" data-id="element-133">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-134">
        <span className="inline-block px-4 py-1.5 bg-[#FFC501]/10 text-[#FFC501] rounded-full text-sm font-medium mb-6" data-id="element-135">
          LIMITED AVAILABILITY
        </span>
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-outfit font-bold mb-6 sm:mb-8 text-white leading-tight" data-id="element-136">
          Ready to Transform
          <br className="hidden sm:inline" data-id="element-137" /> Your Career?
        </h2>
        <p className="text-lg sm:text-xl text-gray-300 mb-10 sm:mb-12 max-w-3xl mx-auto" data-id="element-138">
          Apply now for ApplyPass Platinum. Only 4 spots remaining for Q1. Our
          clients see an average 127% increase in compensation within 3-4
          months.
        </p>
        <div className="flex flex-col sm:flex-row justify-center items-center gap-6" data-id="element-139">
          <Button variant="gradient-primary" size="lg" className="w-full sm:w-auto text-lg sm:text-xl font-semibold shadow-xl" href="/start" data-id="element-140">
            <CalendarIcon className="mr-2 w-5 h-5" data-id="element-141" /> Schedule a Consultation
          </Button>
          <Button variant="outline" size="lg" className="w-full sm:w-auto text-lg" href="#testimonials" data-id="element-142">
            See Success Stories <ArrowRightIcon className="ml-2 w-5 h-5" data-id="element-143" />
          </Button>
        </div>
        {/* Trust Indicators */}
        <div className="mt-12 flex flex-wrap justify-center items-center gap-6 text-white/60" data-id="element-144">
          <div className="flex items-center gap-2" data-id="element-145">
            <CalendarIcon size={16} data-id="element-146" />
            <span data-id="element-147">30-min consultation</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-148">
            <CheckIcon size={16} data-id="element-149" />
            <span data-id="element-150">No obligation</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-151">
            <LockIcon size={16} data-id="element-152" />
            <span data-id="element-153">100% confidential</span>
          </div>
        </div>
      </div>
    </section>;
};
function CheckIcon(props: React.SVGProps<SVGSVGElement> & {
  size?: number;
}) {
  return <svg width={props.size || 24} height={props.size || 24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-154">
      <polyline points="20 6 9 17 4 12" data-id="element-155" />
    </svg>;
}
function LockIcon(props: React.SVGProps<SVGSVGElement> & {
  size?: number;
}) {
  return <svg width={props.size || 24} height={props.size || 24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props} data-id="element-156">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2" data-id="element-157" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" data-id="element-158" />
    </svg>;
}